const isSameDay = (d1: Date, d2: Date) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

// TODO: 더 자세히?
export const getDateTimeString = (date: Date) => {
  const today = new Date();
  if (isSameDay(date, today)) {
    return '오늘 ' + date.toLocaleTimeString();
  } else {
    return date.toLocaleDateString();
  }
};

export const ISO_LOCAL_DATE = 'YYYY-MM-DD';
